import { useUser } from "../../../../../../contexts/UserContext";
import { Filing } from "../../../../../../models/Filing";
import { FilingSection } from "../../../../../../models/FilingSection";
import SlateTextArea from "../../../../../../components/SlateTextArea/SlateTextArea";
import SectionCommentMoreButton from "./SectionCommentMoreButton";
import moment from "moment";
import { Comment } from "../../../../../../models/Comment";

interface Props {
  filing: Filing;
  section: FilingSection;
  comment: Comment;
}

const SectionCommentListItem: React.FC<Props> = ({
  filing,
  section,
  comment,
}) => {
  const { users } = useUser();
  const user = users.find((u) => u._id === comment.createdById);

  return (
    <div
      key={comment._id}
      className="pl-2 pr-1 space-y-1 text-sm border-l border-muted"
    >
      {/* Header Row: Name + More Button */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="text-sm font-semibold">{user?.name}</div>
          {` · `}
          {moment(comment.createdAt).fromNow()}
        </div>
        <SectionCommentMoreButton
          filing={filing}
          section={section}
          comment={comment}
        />
      </div>

      {/* Comment content */}
      <SlateTextArea
        id={comment._id}
        initialValue={[...JSON.parse(comment.content)]}
        readOnly={true}
      />
    </div>
  );
};

export default SectionCommentListItem;
